import api from '../index';

export const getMechanicJobCards = () => {
  return api({
    method: 'get',
    url: '/jobcard/get-mechanics-job-cards',
  });
};

export const getMechanicAttendanceList = () => {
  return api({
    method: 'get',
    url: '/attendance/get-attendance-list',
  });
};

export const clockInApi = (data) => {
  return api({
    method: 'post',
    url: '/attendance/check-in',
    data,
  });
};

export const clockOutApi = (data) => {
  return api({
    method: 'post',
    url: '/attendance/check-out',
    data,
  });
};

export const breakStartApi = (data) => {
  return api({
    method: 'post',
    url: '/attendance/break-start',
    data,
  });
};

export const breakEndApi = (data) => {
  return api({
    method: 'post',
    url: '/attendance/break-end',
    data,
  });
};

export const driveInApi = (data) => {
  return api({
    method: 'post',
    url: '/attendance/drive-in',
    data,
  });
};

export const driveOutApi = (data) => {
  return api({
    method: 'post',
    url: '/attendance/drive-out',
    data,
  });
};
export const updateAttendanceDetail = (data) => {
  return api({
    method: 'put',
    url: '/attendance/update-attendance-detail',
    data,
  });
};
export const addAttendanceDetail = (data) => {
  return api({
    method: 'post',
    url: '/attendance/add-attendance-detail',
    data,
  });
};
export const deleteAttendanceDetailApi = (attendanceId) => {
  return api({
    method: 'delete',
    url: '/attendance/delete-attendance-detail',
    data: attendanceId,
  });
};
